import { useI18n } from '@change-corgi/core/react/i18n';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';

type Result = ModelHookResult<{
	title: string;
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();
	const {
		data: {
			petition: { ask },
		},
	} = usePsfSharePageData();

	return {
		data: {
			title: `${translate('fe.pages.petition_share.title')} · ${ask}`,
		},
	};
}
